import React from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-svg-core/styles.css';

interface IconPropsBase {
  text?: string;
  textClassName?: string;
  icon: FontAwesomeIconProps['icon'];
  spin?: boolean;
  dynamicWidth?: boolean;
}

type IconProps = IconPropsBase & React.HTMLAttributes<HTMLSpanElement>;

export default function Icon(props: IconProps) {
  const { text, icon, textClassName, className, spin, dynamicWidth, ...rest } = props;

  const classes = ['inline-flex items-center gap-2'];
  if (className) classes.push(className);

  const iconClasses = ['shrink-0'];

  const textClasses = [''];
  if (textClassName) textClasses.push(textClassName);

  return (
    <span {...rest} className={classes.join(' ')}>
      <FontAwesomeIcon
        icon={icon}
        fixedWidth={!dynamicWidth}
        className={iconClasses.join(' ')}
        spin={spin}
      />
      {text && <span className={textClasses.join(' ')}>{text}</span>}
    </span>
  );
}
